import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import type { MailrailBaseEmailCampaign } from '@feathr/blackbox';
import { CampaignState } from '@feathr/blackbox';
import { Spinner } from '@feathr/components';
import MailrailCampaignEdit from '@feathr/extender/App/EventsPage/CampaignEditPage/MailrailCampaignEdit';
import Page from '@feathr/extender/App/Page';
import CampaignChips from '@feathr/extender/components/CampaignChips';
import CampaignDates from '@feathr/extender/components/CampaignDates';
import { useStore } from '@feathr/extender/state';

function MailrailPartnerMessageEditPage(): JSX.Element {
  const { t } = useTranslation();
  const { messageId } = useParams<{ messageId: string }>();
  const { Campaigns } = useStore();
  const campaign = Campaigns.get(messageId);

  if (campaign.isPending) {
    return (
      <Page>
        <Spinner />
      </Page>
    );
  }

  const name = campaign.name;

  return (
    <Page
      ChipsComponent={<CampaignChips campaign={campaign} />}
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      pageTitle={t('Edit {{- name}}', { name })}
      secondaryText={
        campaign.get('state') !== CampaignState.Draft && <CampaignDates campaign={campaign} />
      }
      title={name}
      width={'wide'}
    >
      <MailrailCampaignEdit campaign={campaign as MailrailBaseEmailCampaign} />
    </Page>
  );
}

export default observer(MailrailPartnerMessageEditPage);
